module.exports = __webpack_public_path__ + "img/r_figure_05.42b3884e.png";